// @flow
import { SingleTreatmentExp } from 'app/common/lib/experiment';
import { type RequestContextType } from 'app/common/react/components/RequestContext';

export const activateGoogleSignInExperiment = (requestContext: RequestContextType) => {
  const experiment = new SingleTreatmentExp(requestContext, 'web_unauth_gplus_deprecation');
  const isEnabled = experiment.enabled(); // activate experiment
  requestContext.experiments.flush();
  return isEnabled;
};

export default activateGoogleSignInExperiment;
